import { createSelector } from 'reselect'
import { getSelectedWorkspace } from '../workspace/reducers'

export const getHistory = createSelector(
  [getSelectedWorkspace],
  state => state.history,
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/state/history/selectors.ts